/* eslint-disable no-param-reassign */

// node modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';

// app modules: components
import InfoTile from 'components/InfoTile';

class RecipeOutput extends Component {
  static propTypes = {
    output: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.string,
        text: PropTypes.string,
        measure: PropTypes.arrayOf(
          PropTypes.shape({
            quantity: PropTypes.shape({
              type: PropTypes.string,
              value: PropTypes.string,
            }),
            unit: PropTypes.shape({
              system: PropTypes.string,
              type: PropTypes.string,
              value: PropTypes.string,
            }),
          }),
        ),
      }),
    ).isRequired,
  };

  static formatMeasure(measure) {
    const value = [];

    if (measure.quantity) {
      value.push(measure.quantity.value);
    }

    if (measure.unit) {
      value.push(measure.unit.value);
    }

    return value.join(' ');
  }

  render() {
    const { output, ...others } = this.props;

    if (output.length > 0) {
      const hasCount = output.filter(item => item.type === 'count');
      const hasMeasure = output.filter(item => item.type === 'measure');
      let result = {
        prefix: [],
        count: null,
        suffix: [],
      };

      if (hasCount.length > 0) {
        result = output.reduce(
          (mapping, item) => {
            const destination = mapping.count === null ? 'prefix' : 'suffix';
            if (item?.type === 'count') {
              mapping.count = item.text;
            } else if (item?.type === 'measure') {
              const measuresItems = item.measure;
              measuresItems.forEach(measure => {
                if (measure.unit !== null && measure.quantity !== null) {
                  mapping[destination].push(`${measure.quantity.value} ${measure.unit.value}`);
                } else if (measure.quantity) {
                  mapping[destination].push(`${measure.quantity.value}`);
                }
              });
            } else if (item) {
              mapping[destination].push(item.text);
            }

            return mapping;
          },
          {
            prefix: [],
            count: null,
            suffix: [],
          },
        );
      } else if (hasMeasure.length === 1) {
        result = output.reduce(
          (mapping, item) => {
            if (item?.type === 'measure') {
              mapping.count = RecipeOutput.formatMeasure(item.measure[0]);
            } else if (mapping.count === null) {
              mapping.prefix.push(item.text);
            } else if (item) {
              mapping.suffix.push(item.text);
            }

            return mapping;
          },
          {
            prefix: [],
            count: null,
            suffix: [],
          },
        );
      } else {
        return null;
      }

      return (
        <InfoTile
          title={result.prefix.join(' ')}
          value={result.count}
          subTitle={result.suffix.join(' ')}
          {...others}
        />
      );
    }

    return null;
  }
}

export default RecipeOutput;
